import React from 'react';
const HeroIllustration = () => {
  return (
    <div className="hero-illustration">
      {/* Background Elements */}
      <div className="bg-elements">
        <div className="bg-circle bg-circle-1"></div>
        <div className="bg-circle bg-circle-2"></div>
        <div className="bg-circle bg-circle-3"></div>
      </div>

      {/* Main SVG Illustration */}
      <svg viewBox="0 0 400 400" className="illustration-svg" xmlns="http://www.w3.org/2000/svg">
        {/* Background Circle */}
        <circle
          cx="200"
          cy="200"
          r="180"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          className="rotating-circle"
        />

        {/* Laptop */}
        <g transform="translate(120, 180)">
          <rect x="0" y="0" width="160" height="100" rx="8" fill="currentColor" className="laptop-body" />
          <rect x="8" y="8" width="144" height="84" rx="4" fill="currentColor" className="laptop-screen-bg" />
          <rect x="16" y="16" width="128" height="68" rx="2" fill="currentColor" className="laptop-screen" />

          {/* Code Lines */}
          <rect x="24" y="24" width="40" height="2" fill="#3b82f6" />
          <rect x="24" y="32" width="60" height="2" fill="#06b6d4" />
          <rect x="24" y="40" width="35" height="2" fill="#10b981" />
          <rect x="24" y="48" width="50" height="2" fill="#f59e0b" />
          <rect x="24" y="56" width="45" height="2" fill="#8b5cf6" />

          {/* Laptop Base */}
          <ellipse cx="80" cy="105" rx="85" ry="8" fill="currentColor" className="laptop-shadow" />
        </g>

        {/* Floating Code Elements */}
        <g className="floating-element float-1">
          <circle cx="80" cy="120" r="25" fill="currentColor" className="code-circle primary" />
          <text x="80" y="128" textAnchor="middle" className="code-text primary">
            {"</>"}
          </text>
        </g>

        <g className="floating-element float-2">
          <circle cx="320" cy="140" r="20" fill="currentColor" className="code-circle blue" />
          <text x="320" y="147" textAnchor="middle" className="code-text blue">
            {"{}"}
          </text>
        </g>

        <g className="floating-element float-3">
          <circle cx="60" cy="280" r="18" fill="currentColor" className="code-circle green" />
          <text x="60" y="286" textAnchor="middle" className="code-text green">
            {"()"}
          </text>
        </g>

        <g className="floating-element float-4">
          <circle cx="340" cy="260" r="22" fill="currentColor" className="code-circle purple" />
          <text x="340" y="267" textAnchor="middle" className="code-text purple">
            {"[]"}
          </text>
        </g>

        {/* Geometric Shapes */}
        <polygon points="100,80 120,60 140,80 120,100" fill="currentColor" className="geometric-shape yellow" />

        <rect
          x="280"
          y="320"
          width="30"
          height="30"
          rx="4"
          fill="currentColor"
          className="geometric-shape pink"
          transform="rotate(45 295 335)"
        />
      </svg>

      {/* Floating Particles */}
      <div className="floating-particles">
        <div className="particle particle-1"></div>
        <div className="particle particle-2"></div>
        <div className="particle particle-3"></div>
      </div>
    </div>
  )
}

export default HeroIllustration
